module.exports = __webpack_public_path__ + "img/section-tracks.19afca7b.png";